import * as React from "react";
import Typography from "@mui/material/Typography";
import EmptyCard from "../../../../components/EmptyCard";

export default function EmptyListingCard() {
  const isPropertyManager =
    localStorage.getItem("userType") === "propertymanager" || false;
  return (
    <EmptyCard>
      <Typography variant="body2" color="text.secondary">
        <span>You don't have any listings at this time.</span>
        {isPropertyManager && (
          <span>
            If you want to create a listing you first need to
            <strong> add a property</strong> under the property tab.
          </span>
        )}
      </Typography>
    </EmptyCard>
  );
}
